import { render, staticRenderFns } from "./car-monitor.vue?vue&type=template&id=b275d18e&scoped=true"
import script from "./car-monitor.vue?vue&type=script&lang=js"
export * from "./car-monitor.vue?vue&type=script&lang=js"
import style0 from "./car-monitor.vue?vue&type=style&index=0&id=b275d18e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b275d18e",
  null
  
)

export default component.exports